export default __webpack_public_path__ + "static/media/2-2.5c9c979c.jpg";